"use client";

import * as React from "react";
import { VisuallyHidden } from "@radix-ui/themes";
import { OrganizationDomain } from "../api/endpoint.js";
import { ProviderIcon } from "./provider-icon.js";

interface NameServerIconProps {
  provider?: OrganizationDomain["nameServer"];
}

export const NameServerIcon = ({ provider }: NameServerIconProps) => (
  <>
    <CustomProviderIcon
      provider="aws"
      show={provider === "AwsRoute53"}
      size="2"
    />
    <CustomProviderIcon
      provider="google"
      show={provider === "GoogleDomains"}
      size="2"
    />
    <CustomProviderIcon
      provider="cloudflare"
      show={provider === "CloudFlare"}
      size="2"
    />
    <CustomProviderIcon
      provider="godaddy"
      show={provider === "GoDaddy"}
      size="2"
    />

    {(provider === undefined || provider === "Other") && (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_439_15264)">
          <path
            d="M8.36963 0.84314C12.1559 1.03545 15.1665 4.16625 15.1665 8.00037C15.1663 11.9581 11.9583 15.1662 8.00049 15.1664C4.04256 15.1664 0.833672 11.9583 0.833496 8.00037C0.833496 4.04233 4.04245 0.833374 8.00049 0.833374L8.36963 0.84314ZM1.85596 8.50037C2.0802 11.2918 4.1615 13.5566 6.86475 14.0599C5.68944 12.4359 4.98911 10.5102 4.85498 8.50037H1.85596ZM11.144 8.50037C11.0099 10.5105 10.3098 12.4357 9.13428 14.0599C11.8382 13.5571 13.9198 11.2923 14.144 8.50037H11.144ZM5.85889 8.50037C6.00462 10.4763 6.75172 12.3598 7.99951 13.8978C9.24761 12.3597 9.99445 10.4765 10.1401 8.50037H5.85889ZM6.86572 1.93884C4.16183 2.44193 2.08009 4.70839 1.85596 7.50037H4.85498C4.98905 5.48961 5.68956 3.5633 6.86572 1.93884ZM7.99951 2.10193C6.75148 3.64015 6.00449 5.52408 5.85889 7.50037H10.1401C9.99457 5.5239 9.24784 3.64025 7.99951 2.10193ZM9.1333 1.93884C10.3097 3.56349 11.011 5.48937 11.145 7.50037H14.144C13.9199 4.70785 11.8378 2.44135 9.1333 1.93884Z"
            fill="#2B333B"
          />
        </g>
        <defs>
          <clipPath id="clip0_439_15264">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  </>
);

type IconProps = React.ComponentPropsWithoutRef<typeof ProviderIcon> & {
  show?: boolean;
};

const CustomProviderIcon = ({ show, ...props }: IconProps) => {
  const Wrapper = show ? React.Fragment : VisuallyHidden;
  return (
    <Wrapper>
      <ProviderIcon {...props} provider={props.provider} size="1" />
    </Wrapper>
  );
};
